import { useEffect, useState, useCallback } from 'react'
import {
  startFullScreenLoading,
  endFullScreenLoading,
} from 'app/store/actions/loadSpinner.actions'
import { useDispatch } from 'react-redux'
import * as R from 'ramda'
import MessageAlert from 'app/components/MessageAlert'
import { usePlace } from 'commons/usePlace'
import { useFetcher } from 'libs/fetcher'
import { useIntl } from 'react-intl'
import effects from 'app/effects/effects'
const initialState = {
  type: undefined,
}
const MAX_GROUPS_LIMIT = 10000

const useRoleForm = ({ formRef, isOpen, onError }) => {
  const [state, setState] = useState(initialState)
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const placeId = R.prop('id', usePlace())

  const fetch = useCallback(() => {
    if (isOpen) {
      return Promise.all([
        effects.apis.getPermissions(),
        effects.apis.groupsWithTags({
          placeId,
          limit: MAX_GROUPS_LIMIT,
        }),
      ])
    }

    return Promise.resolve([{ data: [] }, { data: [] }])
  }, [isOpen, placeId])

  const { values, errors, isLoading } = useFetcher(fetch, [
    { data: [] },
    { data: [] },
  ])

  const setRoleType = (formRef) => {
    if (R.prop('current', formRef)) {
      setState(formRef.current.getModel())
    }
  }

  useEffect(() => {
    dispatch(isLoading ? startFullScreenLoading() : endFullScreenLoading())
  }, [dispatch, isLoading])

  useEffect(() => {
    if (errors) {
      onError && onError(errors)
      dispatch(
        MessageAlert.showError({
          message: formatMessage({
            id: 'rolesPermissions.table.editingRole.error.label',
          }),
        }),
      )
    }
  }, [dispatch, errors, formatMessage, onError])

  useEffect(() => {
    setRoleType(formRef)
  }, [formRef])

  const handleChange = () => {
    setRoleType(formRef)
  }

  const resetForm = () => {
    setState({})
  }

  return {
    state,
    data: values,
    onChange: handleChange,
    isLoading,
    resetForm,
  }
}

export default useRoleForm
